import { Outlet } from 'react-router-dom';

import { ROUTES } from 'constants/routes';
import StaffRegisterPage from 'pages/login/staff/register';
import WithNotAuth from 'shared/components/hocs/with-not-auth';

export const REGISTER_STAFF_ROUTE = {
  path: '',
  element: (
    <WithNotAuth>
      <Outlet />
    </WithNotAuth>
  ),
  children: [
    {
      path: ROUTES.REGISTER_STAFF.path,
      element: <StaffRegisterPage />,
    },
  ],
};
